import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Card,
    CardContent,
    Divider,
    Stepper,
    Step,
    StepLabel,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    InputLabel,
    TextField,
    CardHeader,
    Chip,
    IconButton,
    Tooltip,
} from '@mui/material';
import {   Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Breadcrumbs from 'config/Breadcrumb'

import { useNotification } from 'config/Notification';
import {
    fetchAllStandards as fetchStandardsService,
    saveNewStandard,
    saveNewControlByStandard,
    saveNewQuestionByStandardControl,
    fetchControlsByStandardId,
    fetchSubControlsByStandardControl,
    updateStandardById,
    updateControlsById,
    updateSubcontrolsById,
} from 'services/modules/cap/standardservice';

// US-CAP-103: QuestionRenderer for live preview
import QuestionRenderer, { QUESTION_TYPE_LABELS } from '../shared/QuestionRenderer';

// US-CAP-103: Valid question types
const VALID_QUESTION_TYPES = ['five_option', 'yes_no', 'checkbox', 'radio', 'text_box'];

// US-CAP-103: Default answer_config per type
const getDefaultAnswerConfig = (type) => {
    switch (type) {
        case 'five_option': return null;
        case 'yes_no': return { labels: { yes: 'Yes', no: 'No', na: 'N/A' } };
        case 'checkbox': return { options: ['Option 1', 'Option 2'], minSelect: 1, maxSelect: 2 };
        case 'radio': return { options: ['Option 1', 'Option 2', 'Option 3'] };
        case 'text_box': return { placeholder: '', reviewerInstructions: '', maxLength: 2000 };
        default: return null;
    }
};


const ConfigureQuestions = () => {
    const standardTypes = [
        { id: 'standard-based', name: 'Standard Based' },
        { id: 'domain-based', name: 'Domain Based' }
    ];

    const [standardType, setStandardType] = useState(standardTypes[0].id);
    const [selectedStandards, setSelectedStandards] = useState([]);
    const [controls, setControls] = useState([]);
    const [questions, setQuestions] = useState([]);
    const activeStep = 0;

    const { openNotification } = useNotification();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isStep1Editing,setIsStep1Editing]=useState(false)

    const [isStep2Editing, setIsStep2Editing] = useState(false);
   const [editControlId, setEditControlId] = useState(null); // Track the ID of the control being edited
   
   const [isStep3Editing, setIsStep3Editing] = useState(false);
   const [editQuestionId, setEditQuestionId] = useState(null); 
   const [openStep3, setOpenStep3] = React.useState(false);
    // Fetch standards data based on the selected standard type
    const fetchStandardsData = async () => {
        try {
            const response = await fetchStandardsService(
                standardType === 'standard-based' ? 'Main Standard' : 'Domain Standard'
            );
            setSelectedStandards(response.data);
        } catch (error) {
            openNotification("Error while fetching data", 'error');
        }
    };

    // Fetch controls based on the selected standard
    const fetchControlsDataByStandard = async (standard) => {
        try {
            const response = await fetchControlsByStandardId({standard});
            setControls(response.data || []);
        } catch (error) {
            openNotification("Error while fetching controls", 'error');
        }
    };

    // Fetch sub-controls based on the selected control
    const fetchSubControlsDataByControl = async (standardId, controlId) => {
        try {
            const response = await fetchSubControlsByStandardControl({standardId, controlId});
            setQuestions(response.data || []);
        } catch (error) {
            openNotification("Error while fetching sub-controls", 'error');
        }
    };
   

    // This method handles to change the pages
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      // This method handles to change the rows per page based on user selection
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
      };



    // Validation schemas for each step
    const validationSchemaStep1 = Yup.object({
        name: Yup.string().required('Required'),
    });
      // Formik setup for step 1
      const formikStep1 = useFormik({
        initialValues: {
            name: '',
            description: '',
            acronym: '',
            group: '',
            status:true
        },
        validationSchema: validationSchemaStep1,
        onSubmit: async (values) => {
            try {
              // Check if there's an ID to determine if it's an edit
            
                let body = {
                    name: values.name,
                    description: values.description,
                    group: standardType === 'standard-based' ? 'Main Standard' : 'Domain Standard',
                    status: values.status
                };
    
                let response;
               
                if (isStep1Editing) {
                    let standarId = values.id; 
                    response = await updateStandardById(standarId, {body }); // Update API
                    if (response.status === 200) {
                        openNotification("Standard updated successfully", 'success');
                        formikStep1.resetForm();
                        fetchStandardsData();
                        setIsStep1Editing(false);
                    }
                } else {
                    response = await saveNewStandard({ body }); 
                    if (response.status === 201) {
                        openNotification("Standard saved successfully", 'success');
                        formikStep1.resetForm();
                        fetchStandardsData();
                        setIsStep1Editing(false);
                    }// Save new standard API
                }
    
            } catch (error) {
                openNotification("Error while saving standard", 'error');
            }
        },
    });
    
    const validationSchemaStep2 = Yup.object({
        standard: Yup.string().required('Required'),
        controlId: Yup.string().required('Required'),
        slno: Yup.string().required('Required'),
        controlName: Yup.string().required('Required'),
      //  controlDescription: Yup.string().required('Required'),
     
    });
  // Formik setup for step 2
  const formikStep2 = useFormik({
    initialValues: {
        standardName: '',
        standard: '',
        controlId: '',
        slno:'',
        controlName: '',
        controlDescription: '',
        status:true
    },
    validationSchema: validationSchemaStep2,
    onSubmit: async (values) => {
        try {
            const body = {
                "Standard": values.standardName,
                "ControlID": values.controlId,
                "slno": values.slno,
                "Title": values.controlName,
                "Description": values.controlDescription,
                "status": values.status
            };
    
            if (isStep2Editing) {
                // Update existing control
               
                let controlId=editControlId;
                let standarId=values.standard;
                const response = await updateControlsById(controlId,standarId,{body});
                if (response.status === 200) {
                    openNotification("Control updated successfully", 'success');
                    fetchControlsDataByStandard(values.standard);
                    let standardName= values.standardName;
                    let standard =values.standard;
                   
                    formikStep2.resetForm();
                    formikStep2.setFieldValue('standardName', standardName);
                    formikStep2.setFieldValue('standard', standard);
                    setIsStep2Editing(false); // Exit editing mode
                    setEditControlId(null); // Reset edit control ID
                }
            } else {
                // Save new control
                const response = await saveNewControlByStandard({ standard: values.standard, body });
                if (response.status === 201) {
                    openNotification("Control saved successfully", 'success');
                    fetchControlsDataByStandard(values.standard);
                
                    let standardName= values.standardName;
                    let standard =values.standard;
                   
                    formikStep2.resetForm();
                    formikStep2.setFieldValue('standardName', standardName);
                    formikStep2.setFieldValue('standard', standard);
                }
            }
        } catch (error) {
            openNotification("Error while saving control", 'error');
        }
    }
    
  });

    const validationSchemaStep3 = Yup.object({
        standard: Yup.string().required('Required'),
        control: Yup.string().required('Required'),
        // code change for fixing frontend handling of subcontrol and question display
        subControlId: Yup.string(),
        subControlName: Yup.string(),
        slno: Yup.string().required('Required'),
        // US-CAP-103
        question_type: Yup.string().oneOf(VALID_QUESTION_TYPES).required('Required'),
    }); 

    // Formik setup for step 3
    const formikStep3 = useFormik({
        initialValues: {
            standardName: '',
            standard: '',
            control: '',
            subControlId: '',
            subControlName: '',
            slno: '',
            questionId: '',
            questionName: '',
            questionDescription: '',
            status: true,
            // US-CAP-103
            question_type: 'five_option',
            answer_config: null,
        },
        validationSchema: validationSchemaStep3,
        onSubmit: async (values) => {
            try {
                const body = {
                    "Standard": values.standardName,
                    "ControlID": values.control,
                    "SubControlID": values.subControlId,
                    "slno": values.slno,
                    "SubControlName": values.subControlName,
                    "Question_ID": values.questionId,
                    "Question": values.questionName,
                    "Description": values.questionDescription,
                    "status": values.status,
                    // US-CAP-103
                    "question_type": values.question_type,
                    "answer_config": values.answer_config,
                };
                let standard = values.standard;
                let standardName = values.standardName;
                let control = values.control;
                // code change for fixing frontend handling of subcontrol and question display
                let subControlIdValue = values.subControlId;
                let subControlNameValue = values.subControlName;
                // Check if we are in edit mode
                if (isStep3Editing) {
                    // Update existing question logic
                    let subcontrolId = editQuestionId;
                    let standarId = values.standard;
                    const response = await updateSubcontrolsById(subcontrolId, standarId, { body });
                    // code change for fixing frontend handling of subcontrol and question display
                    if (response?.status === 409) {
                        openNotification(response.data.message || "Conflict", 'error');
                        return;
                    }
                    if (response.status === 200) {
                        openNotification("Question updated successfully", 'success');
                    }
                } else {
                    // Save new question logic
                    const response = await saveNewQuestionByStandardControl({ standard, body });
                    // code change for fixing frontend handling of subcontrol and question display
                    if (response?.status === 409) {
                        openNotification(response.data.message || "Conflict", 'error');
                        return;
                    }
                    if (response.status === 201) {
                        openNotification("Question saved successfully", 'success');
                    }
                }

                fetchSubControlsDataByControl(formikStep3.values.standard, formikStep3.values.control);

                formikStep3.resetForm();
                formikStep3.setFieldValue('standardName', standardName);
                formikStep3.setFieldValue('standard', standard);
                formikStep3.setFieldValue('control', control);
                formikStep3.setFieldValue('question_type', 'five_option');
                formikStep3.setFieldValue('answer_config', null);
                // code change for clearing subcontrol fields after successful save in configurator
                setIsStep3Editing(false); // Reset editing mode

            } catch (error) {
                // code change for fixing frontend handling of subcontrol and question display
                if (error.response?.status === 409) {
                    openNotification(error.response.data.message || "Conflict", 'error');
                } else {
                    openNotification("Error while saving question", 'error');
                }
            }
        },
    });
    
   
    const handleEditQuestionClick = (question) => {
        setIsStep3Editing(true);
        setEditQuestionId(question.id);

        formikStep3.setFieldValue('subControlId', question.SubControlID);
        formikStep3.setFieldValue('subControlName', question.SubControlName);
        formikStep3.setFieldValue('slno', question.slno);
        formikStep3.setFieldValue('questionId', question.Question_ID);
        formikStep3.setFieldValue('questionName', question.Question);
        formikStep3.setFieldValue('questionDescription', question.Description ?? '');
        formikStep3.setFieldValue('status', question.status);
        // US-CAP-103: restore question_type and answer_config
        formikStep3.setFieldValue('question_type', question.question_type || 'five_option');
        formikStep3.setFieldValue('answer_config', question.answer_config || getDefaultAnswerConfig(question.question_type || 'five_option'));
    };
    useEffect(() => {
        fetchStandardsData();
        if(activeStep===0){
            formikStep1.resetForm();
            setIsStep1Editing(false);
        }else if(activeStep===1){
            formikStep2.resetForm();
            setIsStep2Editing(false);
            setControls([]);
        } else if(activeStep===2){
            formikStep3.resetForm();
            setIsStep3Editing(false);
            setQuestions([]);
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [standardType]);
  
    useEffect(() => {
  
            // Find the selected standard name
   
        if (formikStep2.values.standard) {
            const selectedStandard = selectedStandards.find(
                (standard) => standard.id === formikStep2.values.standard
            );
            
            if (selectedStandard) {
                formikStep2.setFieldValue('standardName', selectedStandard.stdid);
            }
            fetchControlsDataByStandard(formikStep2.values.standard);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formikStep2.values.standard]);

    useEffect(()=>{
        if(controls.length>0){
         formikStep2.setFieldValue('slno', (controls.length+1));
        }else{
         formikStep2.setFieldValue('slno', (1));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
     },[controls])
    useEffect(() => {
        if (formikStep3.values.standard) {
            const selectedStandard = selectedStandards.find(
                (standard) => standard.id === formikStep3.values.standard
            );
            
            if (selectedStandard) {
                formikStep3.setFieldValue('standardName', selectedStandard.stdid);
            }
            fetchControlsDataByStandard(formikStep3.values.standard);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formikStep3.values.standard]);

    useEffect(() => {
        if (formikStep3.values.standard && formikStep3.values.control) {
            fetchSubControlsDataByControl(formikStep3.values.standard, formikStep3.values.control);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formikStep3.values.standard, formikStep3.values.control]);

  useEffect(()=>{
       if(questions.length>0){
        formikStep3.setFieldValue('slno', (questions.length+1));
       }else{
        formikStep3.setFieldValue('slno', (1));
       }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    },[questions])



    const handleStep3StatusChange = (event) => {
        const newStatus = event.target.value === 'true';
        if (!newStatus) { // If status is being changed to 'Inactive'
            setOpenStep3(true);
        } else {
            formikStep3.setFieldValue('status', true); // Set status to 'Active'
        }
    };

    const handleStep3ConfirmInactive = () => {
        formikStep3.setFieldValue('status', false); 
        setOpenStep3(false); 
    };

    const handleStep3Close = () => {
        setOpenStep3(false);
    };
    // Steps for the stepper
    const steps = ['Add Standard', 'Add Control', 'Add Question'];
  

    const formContainerStyle = {
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'center',
    };

    const tableContainerStyle = {
        marginBottom: '20px',
    };

    const centerCardStyle = {
        textAlign: 'center',
    };



    const dividerStyle = {
        margin: '20px 0',
    };
    const radioGroupStyle = {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px', // Adjust the spacing between the radio buttons if needed
    };
    return (
        <div className='main-cont'>
            <Card>
            <CardHeader
          title={
            <React.Fragment>
              <div className="card-head">
                <div className="flex-head">
                  <label className="label">
                  <Breadcrumbs paths={['CAP Configurator','Configure Questions']} />
                  </label>
                </div>
                <div>
                  <Button
                    variant="contained"
                    className="back font"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </Button>
                </div>
              </div>
            </React.Fragment>
          }
        />
                <CardContent>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Select Standard Type</FormLabel>
                            <RadioGroup
                                aria-label="standard-type"
                                name="standardType"
                                value={standardType}
                                onChange={(e) => setStandardType(e.target.value)}
                                style={radioGroupStyle} // Apply the styles here
                            >
                                {standardTypes.map((type) => (
                                    <FormControlLabel
                                        key={type.id}
                                        value={type.id}
                                        control={<Radio />}
                                        label={type.name}
                                    />
                                ))}
                            </RadioGroup>
                            <b>Standard Based 70% & Domain Based 30%</b>
                        </FormControl>
                    <Divider style={dividerStyle} />
                    {standardType && (
                        <>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <Divider style={dividerStyle} />
                            <CardContent style={centerCardStyle}>
                          <div style={formContainerStyle}>
                                        <Card className="row company-screen-bg col-md-10">
                                            <CardContent>
                                                <form onSubmit={formikStep3.handleSubmit}>
                                                <div className="row "> 
                                                    <FormControl className='col-md-6 px-2' margin="normal">
                                                    <InputLabel htmlFor="standard">Standard</InputLabel>
                                                        <Select
                                                            name="standard"
                                                              label="Standard"
                                                            value={formikStep3.values.standard}
                                                            onChange={formikStep3.handleChange}
                                                            error={formikStep3.touched.standard && Boolean(formikStep3.errors.standard)}
                                                        >
                                                            {selectedStandards && selectedStandards.map((standard) => (
                                                                <MenuItem key={standard.id} value={standard.id}>
                                                                    {standard.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {formikStep3.touched.standard && formikStep3.errors.standard && (
                                                            <div className="error-message">{formikStep3.errors.standard}</div>
                                                        )}
                                                    </FormControl>
                                                    <FormControl className='col-md-6 px-2'  margin="normal">
                                                    <InputLabel htmlFor="control">Control</InputLabel>
                                                        <Select
                                                            name="control"
                                                              label="Control"
                                                            value={formikStep3.values.control}
                                                            onChange={formikStep3.handleChange}
                                                            error={formikStep3.touched.control && Boolean(formikStep3.errors.control)}
                                                        >
                                                            {controls.map((control) => (
                                                                <MenuItem key={control.Control} value={control.ControlID}>
                                                                    {control.Title}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {formikStep3.touched.control && formikStep3.errors.control && (
                                                            <div className="error-message">{formikStep3.errors.control}</div>
                                                        )}
                                                    </FormControl>
                                                    {/* <FormControl className='col-md-2 px-2'  margin="normal">
                                                        <TextField
                                                            label=" Sl. No."
                                                            name="slno"
                                                            disabled={!isStep2Editing} 
                                                            onChange={formikStep3.handleChange}
                                                            value={formikStep3.values.slno}
                                                            error={formikStep3.touched.slno && Boolean(formikStep3.errors.slno)}
                                                            helperText={formikStep3.touched.slno && formikStep3.errors.slno}
                                                        />
                                                    </FormControl> */}
                                                    </div>
                                                    <div className="row "> 
                                                    <FormControl className='col-md-6 px-2' margin="normal">
                                                        <TextField
                                                            label="SubControl ID"
                                                            name="subControlId"
                                                            onChange={formikStep3.handleChange}
                                                            value={formikStep3.values.subControlId}
                                                            error={formikStep3.touched.subControlId && Boolean(formikStep3.errors.subControlId)}
                                                            helperText={formikStep3.touched.subControlId && formikStep3.errors.subControlId}
                                                        />
                                                    </FormControl>
                                                    
                                                    <FormControl  className='col-md-6 px-2' margin="normal">
                                                        <TextField
                                                            label="Sub-Control"
                                                            name="subControlName"
                                                            onChange={formikStep3.handleChange}
                                                            value={formikStep3.values.subControlName}
                                                            error={formikStep3.touched.subControlName && Boolean(formikStep3.errors.subControlName)}
                                                            helperText={formikStep3.touched.subControlName && formikStep3.errors.subControlName}
                                                        />
                                                    </FormControl>
                                                    </div>
                                                    <div className="row "> 
                                                    <FormControl className='col-md-6 px-2'  margin="normal">
                                                        <TextField
                                                            label="Question Id"
                                                            name="questionId"
                                                            onChange={formikStep3.handleChange}
                                                            value={formikStep3.values.questionId}
                                                            error={formikStep3.touched.questionId && Boolean(formikStep3.errors.questionId)}
                                                            helperText={formikStep3.touched.questionId && formikStep3.errors.questionId}
                                                        />
                                                    </FormControl>
                                                   
                                                    <FormControl className='col-md-6 px-2' margin="normal">
                                                        <TextField
                                                            label="Question"
                                                            name="questionName"
                                                            onChange={formikStep3.handleChange}
                                                            value={formikStep3.values.questionName}
                                                            error={formikStep3.touched.questionName && Boolean(formikStep3.errors.questionName)}
                                                            helperText={formikStep3.touched.questionName && formikStep3.errors.questionName}
                                                        />
                                                    </FormControl>
                                                    </div>
                                                    <FormControl fullWidth margin="normal">
                                                        <TextField
                                                            label="Description"
                                                            name="questionDescription"
                                                            onChange={formikStep3.handleChange}
                                                            value={formikStep3.values.questionDescription}
                                                            error={formikStep3.touched.questionDescription && Boolean(formikStep3.errors.questionDescription)}
                                                            helperText={formikStep3.touched.questionDescription && formikStep3.errors.questionDescription}
                                                            multiline
                                                            rows={1} // Initially show 3 rows
                                                            maxRows={Infinity} // Allow unlimited rows with scroll after 3 lines
                                                       />
                                                    </FormControl>

                                                    {/* US-CAP-103: Question Type Selector */}
                                                    <div className="row mt-2">
                                                        <FormControl className='col-md-6 px-2' margin="normal">
                                                            <InputLabel htmlFor="question_type">Question Type</InputLabel>
                                                            <Select
                                                                name="question_type"
                                                                label="Question Type"
                                                                value={formikStep3.values.question_type}
                                                                onChange={(e) => {
                                                                    const newType = e.target.value;
                                                                    formikStep3.setFieldValue('question_type', newType);
                                                                    formikStep3.setFieldValue('answer_config', getDefaultAnswerConfig(newType));
                                                                }}
                                                            >
                                                                {VALID_QUESTION_TYPES.map((t) => (
                                                                    <MenuItem key={t} value={t}>
                                                                        {QUESTION_TYPE_LABELS[t]}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                        <div className='col-md-6 px-2 d-flex align-items-center'>
                                                            <Chip
                                                                label={`Type: ${QUESTION_TYPE_LABELS[formikStep3.values.question_type] || formikStep3.values.question_type}`}
                                                                size="small"
                                                                color="primary"
                                                                variant="outlined"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* US-CAP-103: Answer Config Panel — conditional per type */}
                                                    {formikStep3.values.question_type !== 'five_option' && (
                                                        <div className="row mt-2 p-2" style={{ background: '#f5f7fa', borderRadius: 6, margin: '8px 0' }}>
                                                            <div className="col-md-12 px-2">
                                                                <strong style={{ fontSize: 13 }}>Answer Configuration</strong>
                                                            </div>

                                                            {/* yes_no labels */}
                                                            {formikStep3.values.question_type === 'yes_no' && (
                                                                <div className="row">
                                                                    {['yes', 'no', 'na'].map((key) => (
                                                                        <FormControl key={key} className='col-md-4 px-2' margin="dense">
                                                                            <TextField
                                                                                label={`Label for "${key.toUpperCase()}"`}
                                                                                size="small"
                                                                                value={formikStep3.values.answer_config?.labels?.[key] || ''}
                                                                                onChange={(e) => {
                                                                                    const updated = {
                                                                                        ...formikStep3.values.answer_config,
                                                                                        labels: {
                                                                                            ...formikStep3.values.answer_config?.labels,
                                                                                            [key]: e.target.value,
                                                                                        },
                                                                                    };
                                                                                    formikStep3.setFieldValue('answer_config', updated);
                                                                                }}
                                                                            />
                                                                        </FormControl>
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {/* checkbox + radio: dynamic options list */}
                                                            {(formikStep3.values.question_type === 'checkbox' || formikStep3.values.question_type === 'radio') && (
                                                                <div className="col-md-12">
                                                                    <div style={{ fontSize: 12, marginBottom: 4, color: '#555' }}>Options (min 2)</div>
                                                                    {(formikStep3.values.answer_config?.options || []).map((opt, idx) => (
                                                                        <div key={idx} className="d-flex align-items-center mb-1">
                                                                            <TextField
                                                                                size="small"
                                                                                value={opt}
                                                                                onChange={(e) => {
                                                                                    const opts = [...(formikStep3.values.answer_config?.options || [])];
                                                                                    opts[idx] = e.target.value;
                                                                                    formikStep3.setFieldValue('answer_config', {
                                                                                        ...formikStep3.values.answer_config,
                                                                                        options: opts,
                                                                                    });
                                                                                }}
                                                                                style={{ flex: 1, marginRight: 4 }}
                                                                            />
                                                                            <Tooltip title="Remove option">
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => {
                                                                                        const opts = (formikStep3.values.answer_config?.options || []).filter((_, i) => i !== idx);
                                                                                        formikStep3.setFieldValue('answer_config', {
                                                                                            ...formikStep3.values.answer_config,
                                                                                            options: opts,
                                                                                            maxSelect: Math.min(formikStep3.values.answer_config?.maxSelect || opts.length, opts.length),
                                                                                        });
                                                                                    }}
                                                                                    disabled={(formikStep3.values.answer_config?.options || []).length <= 2}
                                                                                >
                                                                                    <RemoveCircleOutlineIcon fontSize="small" color="error" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </div>
                                                                    ))}
                                                                    <Button
                                                                        size="small"
                                                                        startIcon={<AddCircleOutlineIcon />}
                                                                        onClick={() => {
                                                                            const opts = [...(formikStep3.values.answer_config?.options || []), ''];
                                                                            formikStep3.setFieldValue('answer_config', {
                                                                                ...formikStep3.values.answer_config,
                                                                                options: opts,
                                                                            });
                                                                        }}
                                                                    >
                                                                        Add Option
                                                                    </Button>

                                                                    {/* checkbox-only: minSelect / maxSelect */}
                                                                    {formikStep3.values.question_type === 'checkbox' && (
                                                                        <div className="row mt-1">
                                                                            <FormControl className='col-md-6 px-2' margin="dense">
                                                                                <TextField
                                                                                    label="Min Selections"
                                                                                    size="small"
                                                                                    type="number"
                                                                                    value={formikStep3.values.answer_config?.minSelect || 1}
                                                                                    inputProps={{ min: 1, max: formikStep3.values.answer_config?.options?.length || 2 }}
                                                                                    onChange={(e) => formikStep3.setFieldValue('answer_config', {
                                                                                        ...formikStep3.values.answer_config,
                                                                                        minSelect: parseInt(e.target.value) || 1,
                                                                                    })}
                                                                                />
                                                                            </FormControl>
                                                                            <FormControl className='col-md-6 px-2' margin="dense">
                                                                                <TextField
                                                                                    label="Max Selections"
                                                                                    size="small"
                                                                                    type="number"
                                                                                    value={formikStep3.values.answer_config?.maxSelect || 2}
                                                                                    inputProps={{ min: 1, max: formikStep3.values.answer_config?.options?.length || 2 }}
                                                                                    onChange={(e) => formikStep3.setFieldValue('answer_config', {
                                                                                        ...formikStep3.values.answer_config,
                                                                                        maxSelect: parseInt(e.target.value) || 2,
                                                                                    })}
                                                                                />
                                                                            </FormControl>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* text_box config */}
                                                            {formikStep3.values.question_type === 'text_box' && (
                                                                <div className="col-md-12">
                                                                    <FormControl fullWidth margin="dense">
                                                                        <TextField
                                                                            label="Placeholder text"
                                                                            size="small"
                                                                            value={formikStep3.values.answer_config?.placeholder || ''}
                                                                            onChange={(e) => formikStep3.setFieldValue('answer_config', {
                                                                                ...formikStep3.values.answer_config,
                                                                                placeholder: e.target.value,
                                                                            })}
                                                                        />
                                                                    </FormControl>
                                                                    <FormControl fullWidth margin="dense">
                                                                        <TextField
                                                                            label="Reviewer instructions"
                                                                            size="small"
                                                                            multiline
                                                                            rows={2}
                                                                            value={formikStep3.values.answer_config?.reviewerInstructions || ''}
                                                                            onChange={(e) => formikStep3.setFieldValue('answer_config', {
                                                                                ...formikStep3.values.answer_config,
                                                                                reviewerInstructions: e.target.value,
                                                                            })}
                                                                        />
                                                                    </FormControl>
                                                                    <FormControl className='col-md-4' margin="dense">
                                                                        <TextField
                                                                            label="Max length (chars)"
                                                                            size="small"
                                                                            type="number"
                                                                            value={formikStep3.values.answer_config?.maxLength || 2000}
                                                                            inputProps={{ min: 100, max: 10000 }}
                                                                            onChange={(e) => formikStep3.setFieldValue('answer_config', {
                                                                                ...formikStep3.values.answer_config,
                                                                                maxLength: parseInt(e.target.value) || 2000,
                                                                            })}
                                                                        />
                                                                    </FormControl>
                                                                </div>
                                                            )}

                                                            {/* Live preview */}
                                                            <div className="col-md-12 mt-2 pt-2" style={{ borderTop: '1px solid #ddd' }}>
                                                                <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>Live Preview</div>
                                                                <QuestionRenderer
                                                                    question_type={formikStep3.values.question_type}
                                                                    answer_config={formikStep3.values.answer_config}
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                                 <div className='row col-md-12 px-2' style={{ alignItems: 'center' }}>
                                                                    <FormControl component="fieldset" className='d-flex' margin="normal">
                                                                        {/* <FormLabel component="legend" style={{ marginRight: '16px' }}>Status</FormLabel> */}
                                                                        <RadioGroup
                                                                            row
                                                                            aria-label="status"
                                                                            name="status"
                                                                            value={formikStep3.values.status ? 'true' : 'false'}
                                                                            onChange={handleStep3StatusChange}
                                                                        >
                                                                            <FormControlLabel value="true" control={<Radio />} label="Active" />
                                                                            <FormControlLabel value="false" control={<Radio />} label="Inactive" />
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </div>
                                                          
                                                    <div  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                 
                                                  
                                        <Button color="primary"
                                        className='mx-3'
                                        variant="contained" type="submit">
                                                {isStep3Editing ? 'Update' : 'Save'}
                                            </Button>
                                                       <Button
                                                            variant="contained"
                                                            className="danger"
                                                            onClick={() => {
                                                            let standard = formikStep3.values.standard;
                                                            let standardName= formikStep3.values.standardName;
                                                            let control =formikStep3.values.control;
                                                        
                                                            formikStep3.resetForm();
                                                            formikStep3.setFieldValue('standardName', standardName);
                                                            formikStep3.setFieldValue('standard', standard);
                                                            formikStep3.setFieldValue('control', control);
                                                            formikStep3.setFieldValue('slno', questions.length>0?questions.length+1:1);
                                                            formikStep3.setFieldValue('question_type', 'five_option');
                                                            formikStep3.setFieldValue('answer_config', null);
                                                                setIsStep3Editing(false); // Exit editing mode
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                    <Dialog
                                                        open={openStep3}
                                                        onClose={handleStep3Close}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                    >
                                                        <DialogTitle id="alert-dialog-title">{"Confirm Inactive Status"}</DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description">
                                                            Would you really like to change the status to "Inactive"?.
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button onClick={handleStep3Close} color="primary">
                                                                Cancel
                                                            </Button>
                                                            <Button onClick={handleStep3ConfirmInactive} color="secondary" autoFocus>
                                                                Ok
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </form>
                                            </CardContent>
                                        </Card>
                                    </div>
                               
                                {questions.length > 0 && (
                                    <div style={tableContainerStyle}>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ justifyContent: 'center', textAlign: 'center'}}>Standard</TableCell>
                                                        <TableCell sx={{ justifyContent: 'center', textAlign: 'center'}}>ControlID</TableCell>
                                                        <TableCell> Sl. No.</TableCell>
                                                        <TableCell>SubControlID</TableCell>
                                                        <TableCell>SubControlName</TableCell>
                                                        <TableCell>QuestionID</TableCell>
                                                        <TableCell>Question</TableCell>
                                                        {/* US-CAP-103: Question type column */}
                                                        <TableCell>Type</TableCell>
                                                        <TableCell>Status</TableCell>
                                                        <TableCell>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {questions.map((question, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ justifyContent: 'center', textAlign: 'center'}}>{question.Standard}</TableCell>
                                                            <TableCell sx={{ justifyContent: 'center', textAlign: 'center'}}>{question.ControlID}</TableCell>
                                                            <TableCell>{question.slno}</TableCell>
                                                            {/* code change for fixing frontend handling of subcontrol and question display */}
                                                            <TableCell>{question.SubControlID || 'General'}</TableCell>
                                                            <TableCell style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                                {question.SubControlName || 'No SubControl'}</TableCell>
                                                            <TableCell>{question.Question_ID}</TableCell>
                                                            <TableCell style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                                {question.Question}</TableCell>
                                                            {/* US-CAP-103: Question type badge */}
                                                            <TableCell>
                                                                <Chip
                                                                    label={QUESTION_TYPE_LABELS[question.question_type] || 'Five Option'}
                                                                    size="small"
                                                                    color={question.question_type && question.question_type !== 'five_option' ? 'secondary' : 'default'}
                                                                    variant="outlined"
                                                                />
                                                            </TableCell>
                                                            <TableCell>{question.status ? 'Active' : 'Inactive'}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handleEditQuestionClick(question)}
                                                                >
                                                                    Edit
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <TablePagination
                                                rowsPerPageOptions={[10, 25, 100]}
                                                component="div"
                                                count={questions.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                    </div>
                                )}
                                <Divider style={dividerStyle} />
                            </CardContent>
                   
                        </>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};
export default ConfigureQuestions;